import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import useDeviceDetection from '../../hooks/useDeviceDetection';
import FooterSocialLinks from '../FooterSocialLinks/FooterSocialLinks';
import ButtonLink from '../interface/ButtonLink';
import Link from '../Link';
import { CopyrightText, Cta, CtaTitle, Links, LinkItem, Nav, Wrapper } from './FooterBottom.styles';
import { sendGAEvent } from '../../utils/analytics';

const FooterBottom = () => {
  const { isDesktop } = useDeviceDetection();
  const { t } = useTranslation('common');

  const handleMembershipClick = () => {
    sendGAEvent('outbound_click_purchase', {
      event_category: 'outbound_click',
      event_label: 'membership_form',
      link_url: t('footer.ctaUrl'),
      page_location: window.location.href,
      page_title: document.title,
    });
  };

  return (
    <Wrapper>
      <Nav>
        <CopyrightText>{t('footer.copyright')}</CopyrightText>
        <Links>
          <LinkItem>
            <Link href={t('footer.links.privacy.link')}>{t('footer.links.privacy.label')}</Link>
          </LinkItem>
          <LinkItem>
            <Link href={t('footer.links.terms.link')}>{t('footer.links.terms.label')}</Link>
          </LinkItem>
          <LinkItem>
            <a href={t('footer.links.bravoure.link')} target="_blank" rel="noreferrer">
              {t('footer.links.bravoure.label')}
            </a>
          </LinkItem>
        </Links>
        {!isDesktop && <FooterSocialLinks />}
      </Nav>
      <Cta>
        <CtaTitle>{t('footer.ctaTitle')}</CtaTitle>
        <ButtonLink href={t('footer.ctaUrl')} type="external" onClick={handleMembershipClick}>
          {`${t('footer.ctaButton')}`}
        </ButtonLink>
      </Cta>
    </Wrapper>
  );
};

export default FooterBottom;
